import { Suspense } from "react";
import LoadingProvider from "@/components/customs/LoadingProvider";
import { NavigationEvents } from "@/components/customs/NavigationEvents";
import { AuthRedirectHandler } from "@/components/customs/AuthRedirectHandler";
import { Toaster } from "sonner";
import VersionBadge from "@/components/ui/VersionBadge";
import { DocumentLocale } from "@/components/DocumentLocale";

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <LoadingProvider>
      <DocumentLocale />
      <Suspense fallback={null}>
        <NavigationEvents />
        <AuthRedirectHandler />
      </Suspense>
      <div className="overflow-x-clip w-full">{children}</div>
      <Toaster />
      <VersionBadge />
    </LoadingProvider>
  );
}
